import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface InternalDocument {
  name: string;
  api_token: string;
}

export interface InternalDocumentDetaiInfor {
  errors: unknown;
  InternalDocument: InternalDocument;
  isAuthenticated: boolean;
}

@Module
export default class InternalDocumentDetailModule
  extends VuexModule
  implements InternalDocumentDetaiInfor
{
  errors = {};
  InternalDocument = {} as InternalDocument;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get internalDocumentDetail() {
    return this.internalDocumentDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.INTERNAL_DOCUMENT_DETAIL_DATA](InternalDocumentDetail) {
    this.internalDocumentDetailData = InternalDocumentDetail;
  }

  @Action
  [Actions.INTERNAL_DOCUMENT_DETAIL](payload) {
    return ApiService.getDataDetail("/vanbannoibo", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.INTERNAL_DOCUMENT_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
